import React from "react";
import { useParams } from "react-router-dom";
import ClientChatPage from "./ClientChatPage";
import styles from "./ClientChatPage.module.css";

/** Маршрут страницы на целевом сайте: /chat/:uuid */
export const CLIENT_CHAT_ROUTE_PATH = "/chat/:uuid";

const ClientChatRoute: React.FC = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const normalizedUuid = String(uuid ?? "").trim();

  if (!normalizedUuid) {
    return (
      <div className={styles.page}>
        <div className={styles.state}>UUID не указан в адресе страницы</div>
      </div>
    );
  }

  return <ClientChatPage uuid={normalizedUuid} />;
};

export default ClientChatRoute;
